export const IconArrowDown = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconArrowDown_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconArrowDown_svg__a)">
        <path d="M12 21.575q-.2 0-.375-.062a.9.9 0 0 1-.325-.213l-5.6-5.6a.95.95 0 0 1-.275-.7q0-.425.275-.7a.93.93 0 0 1 .712-.288.98.98 0 0 1 .688.288l3.9 3.875V3q0-.424.287-.712A.97.97 0 0 1 12 2q.424 0 .713.288Q13 2.575 13 3v15.175l3.875-3.875q.3-.3.712-.3.413 0 .713.3.275.3.275.712a.93.93 0 0 1-.275.688l-5.6 5.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063" />
      </g>
    </svg>
  );
};
